@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.rides
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.rides.NewRideRequestDto


object RequestRideEndpoint : EndPoint<RequestRideEndpoint.Request, RequestRideEndpoint.Response>() {
    class Request(
        val request: NewRideRequestDto,
        val fcmToken: String? = null,
        val isAndroid: Boolean? = null
    )

    class Response(
        val requestId: KmmLong,
        val bookingKey: String,
        val passengerRideDto: PassengerRideDto
    )

    val RIDE_LIMIT_EXCEEDED = "3"
}